<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="1100"
    :maskClosable="true"
    placement="right"
    @close="close"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="协议名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="50"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: '请输入协议名称(限制20个字)' },
                ],
              },
            ]"
            placeholder="请输入协议名称"
          />
        </a-form-item>
        <a-form-item
          label="协议版本"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="20"
            v-decorator="[
              'version',
              {
                rules: [
                  { required: true, message: '请输入协议版本(限制20个字)' },
                ],
              },
            ]"
            placeholder="请输入协议版本"
          />
        </a-form-item>
        <a-form-item
          label="协议类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-multi-select-tag
            v-decorator="[
              'asoActivity',
              { rules: [{ required: true, message: '请选择协议类型' }] },
            ]"
            :triggerChange="true"
            dictCode="protocol_flag"
          />
        </a-form-item>
        <a-form-item
          label="协议格式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="fieldValue"
            v-decorator="[
              'protocolType',
              { rules: [{ required: true, message: '请选择协议格式' }] },
            ]"
            :triggerChange="true"
            dictCode="protocol_type"
          />
        </a-form-item>
        <a-form-item
          label="是否必读"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            v-decorator="[
              'readFlag',
              {
                rules: [{ required: true, message: '请选择是否必读' }],
              },
            ]"
          >
            <a-radio :value="'1'"> 必读 </a-radio>
            <a-radio :value="'0'"> 非必读 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="阅读时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="this.form.getFieldValue('readFlag') == 1"
        >
          <a-input-number
            v-decorator="[
              'readTime',
              {
                rules: [
                  { required: this.checkRequired(), message: '请输入阅读时间' },
                ],
              },
            ]"
            :min="0"
            :max="20"
          />{{ '秒' }}
        </a-form-item>
        <a-form-item
          label="协议文件(.pdf)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showPdf"
        >
          <a-input
            v-decorator="[
              'pdfSaveUrl',
              { rules: [{ required: showPdf, message: '请上传协议文件' }] },
            ]"
            disabled
            style="width: 80%"
          />
          <a-upload
            name="file"
            :headers="headers"
            :action="action"
            :show-upload-list="false"
            :before-upload="beforeUpload"
            @change="handleChange"
            accept=".pdf,.xls,.xlsx"
          >
            <a-button> <a-icon type="upload" /> Upload </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item
          label="协议内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showEditor"
        >
          <input
            type="textarea"
            v-show="false"
            v-decorator="[
              'content',
              {
                trigger: 'blur',
                rules: [{ required: showEditor, message: '请输入协议内容' }],
              },
            ]"
          />
          <tinymce-editor
            :value="this.form.getFieldValue('content')"
            @change="getMyValue"
          />
        </a-form-item>
        <a-form-item
          label="协议内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-show="showTextarea"
        >
          <a-textarea
            v-decorator="[
              'contentText',
              {
                rules: [{ required: showTextarea, message: '请输入协议内容' }],
              },
            ]"
            rows="4"
            placeholder="请输入协议内容"
          />
        </a-form-item>
        <a-form-item
          label="是否启用"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            v-decorator="[
              'status',
              {
                rules: [{ required: true, message: '请选择是否启用' }],
              },
            ]"
          >
            <a-radio :value="'1'"> 启用 </a-radio>
            <a-radio :value="'0'"> 不启用 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="恒生警示ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="['warningId']"
            :triggerChange="true"
            dictCode="warning_id"
          />
        </a-form-item>
        <a-form-item
          label="关联基金"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-checkbox
            :indeterminate="indeterminate"
            :checked="checkAll"
            @change="onCheckAllChange"
            :disabled="!this.unLockList.length > 0"
          >
            选择全部
          </a-checkbox>
          <span style="margin-left: 15px"
            >已选择 {{ checkedList.length }} 个 / 可选产品
            {{ unLockList.length }} 个</span
          >

          <span style="margin-left: 15px"
            >产品代码:<a-input
              @pressEnter="searchFundByCode"
              v-model="fundValue"
              style="width: 20%; margin-left: 10px"
              placeholder="请输入产品代码"
            /><a-button
              style="margin-left: 10px"
              type="primary"
              icon="search"
              @click="searchFundByCode"
              >查询</a-button
            >
            <a-button
              type="primary"
              @click="searchReset"
              icon="reload"
              style="margin-left: 10px"
              >重置</a-button
            ></span
          >

          <a-checkbox-group
            class="optionsBox"
            v-model="checkedList"
            @change="onAppChange"
          >
            <a-row>
              <a-col
                :span="8"
                v-for="(item, index) in AsoFundCodeList"
                :key="index"
              >
                <a-checkbox
                  :value="item.fundCode"
                  style="margin-bottom: 10px"
                  :class="item.isColor ? 'current' : ''"
                  >{{ item.fundName }}</a-checkbox
                >
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction, postTag } from '@/api/manage';
import pick from 'lodash.pick';
import JMultiSelectTag from '@/components/dict/JMultiSelectTag';
import JUpload from '@/components/jeecg/JUpload';
import { getFileAccessHttpUrl } from '@/api/manage';
import tinymceEditor from '@/components/tools/tinymceEditor';

export default {
  name: 'ProtocolModal',
  components: {
    JMultiSelectTag,
    JUpload,
    tinymceEditor,
  },
  data() {
    return {
      fundValue: '', //搜索基金代码
      indeterminate: false,
      checkAll: false,
      plainOptions: [
        { value: 1, label: '王小明王小明王小明王小明' },
        { value: 2, label: '孙芷蕾王小明王小明王小明王小明' },
        { value: 3, label: '张亦寒王小明王小明王小明王小明' },
        { value: 4, label: '李天荷王小明王小明王小明王小明' },
        { value: 5, label: '孟冰枫王小明王小明王小明王小明' },
        { value: 6, label: '赵谷山王小明王小明王小明王小明' },
        { value: 7, label: '轩辕寄凡王小明王小明王小明王小明' },
        { value: 8, label: '冯以山王小明王小明王小明王小明王小明' },
        { value: 9, label: '韩听白王小明王小明王小明王小明王小明王小明' },
        { value: 10, label: '胡幼南王小明王小明王小明' },
      ],
      checkedList: [],
      unLockList: [],
      noCheck: false,
      alreadyCheckedList: [], //存放禁用的选项
      AsoFundCodeList: [], //关联基金列表
      showPdf: false,
      showEditor: false,
      showTextarea: false,
      editorOption: {
        modules: {
          toolbar: [
            [
              'bold',
              { header: 1 },
              { header: 2 },
              { color: [] },
              { font: [] },
              { size: ['small', false, 'large', 'huge'] },
              'italic',
              'underline',
              'strike',
            ], // toggled buttons
            [
              'blockquote',
              { indent: '-1' },
              { indent: '+1' },
              { align: [] },
              'clean',
            ],
          ],
        },
      },
      headers: {
        authorization: 'authorization-text',
      },
      action:
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_FILE_UPLOAD +
        '/upload',
      form: this.$form.createForm(this),
      imageUrl: '',
      title: '操作',
      width: 1200,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_CONTENT + '/protocol/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/protocol/edit',
      },
    };
  },
  created() {
    this.getAsoFundCode();
  },
  methods: {
    checkRequired() {
      if (this.form.getFieldValue('readFlag') == 1) {
        console.log(11111);
        return true;
      } else {
        console.log(22222);
        return false;
      }
    },
    getMyValue(val) {
      this.form.setFieldsValue({
        content: val,
      });
    },
    /** 选择/取消全部基金
     * @param {any} e
     */
    onCheckAllChange(e) {
      if (e.target.checked) {
        this.$set(this, 'noCheck', false);
        const arr = [];
        this.AsoFundCodeList.forEach((res) => {
          if (!res.disabled) {
            // 全选时，将选项中的value值传给 checkedList
            arr.push(res.fundCode);
          }
        });
        /* this.plainOptions.forEach(res => {
            if (!res.disabled) {
              // 全选时，将选项中的value值传给 checkedList
              arr.push(res.value);
            }
          });*/
        this.$set(this, 'checkedList', arr);
        // console.log('checkedList', this.checkedList);
      } else {
        this.$set(this, 'checkedList', []);
      }
      Object.assign(this, {
        indeterminate: false,
        checkAll: e.target.checked,
      });
    },

    /** 选择基金与全选的checkbox状态关联
     * @param {any} checkedList
     */
    onAppChange(checkedList) {
      if (checkedList.length !== 0) {
        this.$set(this, 'noCheck', false);
      }
      this.indeterminate =
        !!checkedList.length && checkedList.length < this.unLockList.length;
      this.checkAll = checkedList.length === this.unLockList.length;
    },

    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.AsoFundCodeList.forEach((item) => {
        item.isColor = false;
      });

      this.model = Object.assign({}, record);
      this.visible = true;

      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'version',
            'asoActivity',
            'pdfSaveUrl',
            'protocolType',
            'content',
            'contentText',
            'status',
            'readTime',
            'readFlag',
            'warningId'
          )
        );
      });

      if (this.model.protocolType === '1') {
        this.showPdf = true;
        this.showEditor = false;
        this.showTextarea = false;
      } else if (this.model.protocolType === '2') {
        this.showPdf = false;
        this.showEditor = true;
        this.showTextarea = false;
      } else if (this.model.protocolType === '3') {
        this.showPdf = false;
        this.showEditor = false;
        this.showTextarea = true;
      } else {
        this.showPdf = false;
        this.showEditor = false;
        this.showTextarea = false;
      }

      if (!this.model.asoFundCode) {
        this.checkedList = [];
      } else {
        this.checkedList = this.model.asoFundCode.split(',');
      }
    },
    close() {
      this.$emit('handleCancel');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }

          this.model.asoFundCode = this.checkedList.toString();
          let formData = Object.assign(this.model, values);
          if (!this.model.warningId) {
            formData.warningId = '';
          }
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                // that.$emit('ok');
                this.$emit('handleOk');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },

    handleChange(info) {
      this.imageUrl = '';
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          let reUrl = info.file.response.result.url;
          this.imageUrl = getFileAccessHttpUrl(reUrl);
          //showUrl(this.imageUrl);
          //赋值
          this.form.setFieldsValue({
            pdfSaveUrl: getFileAccessHttpUrl(reUrl),
          });

          this.$message.success('上传成功');
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`);
      } else if (info.file.status === 'removed') {
        this.handleDelete(info.file);
      }
    },

    beforeUpload(file) {
      let result = true;
      // console.log(file.type)
      // console.log(file.type.indexOf('pdf'))
      // if (file.type.indexOf('pdf')<0 || file.type.indexOf('xls')<0 || file.type.indexOf('xlsx')<0) {
      //   result = false;
      //   this.$message.error('只允许上传pdf或excel文件');
      // }
      return result;
    },

    fieldValue(e) {
      if (e === '1') {
        //pdf
        this.showPdf = true;
        this.showEditor = false;
        this.showTextarea = false;
      } else if (e === '2') {
        //富文本编辑
        this.showPdf = false;
        this.showEditor = true;
        this.showTextarea = false;
      } else if (e === '3') {
        //纯文本
        this.showPdf = false;
        this.showEditor = false;
        this.showTextarea = true;
      } else {
        this.showPdf = false;
        this.showEditor = false;
        this.showTextarea = false;
      }
    },

    getAsoFundCode() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_PRODUCT +
        '/product/fund/list';
      postTag(getUrl, { pageSize: 1000 }).then((res) => {
        if (res.success) {
          res.result.records.forEach((item) => {
            item.isColor = false;
          });
          console.log(res.result);
          this.AsoFundCodeList = res.result.records;
          this.$set(this, 'unLockList', this.AsoFundCodeList);
        }
      });
    },

    searchReset(){
      this.fundValue = '';
      this.AsoFundCodeList = [];
      this.getAsoFundCode();
    },
    searchFundByCode() {
      this.AsoFundCodeList.forEach((item) => {
        item.isColor = false;
      });
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_PRODUCT +
        '/product/fund/list';
      if (this.fundValue) {
        let parm = { fundCode: this.fundValue };
        postTag(getUrl, parm).then((res) => {
          if (res.success) {
            let arr = [];
            let arrList = this.AsoFundCodeList;
            console.log(this.AsoFundCodeList);
            arrList.forEach((el) => {
              if (el.fundCode === res.result.records[0].fundCode) {
                arr.push(el);
                el.isColor = true;
              }
            });
            this.AsoFundCodeList = arr;
          } else {
            this.$message.info('没有找到匹配的产品！');
          }
        });
      } else {
        this.$message.error('请输入基金代码！');
      }
    },
  },
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.current {
  background: #ccc;
}
</style>
